"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDNT = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _contexts = require("../contexts");
/*
 * Copyright (c) 2024, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * @group Helpers
 * @category DNT
 *
 * @returns {Object} - The returned object containing DNT states and function to update preference
 * @property {boolean} selectedDnt - DNT user preference. Used to determine
 *              if the consent tracking form should be rendered
 * @property {boolean} effectiveDnt - effective DNT value to apply to
 *              analytics layers. Takes defaultDnt into account when selectedDnt is undefined.
 *              If defaultDnt is undefined as well, then SDK default is used.
 * @property {function} updateDnt - takes a DNT choice and creates the dw_dnt
 *              cookie and reauthorizes with SLAS
 */
const useDNT = () => {
  const api = (0, _contexts.useCommerceAPI)();
  const selectedDnt = api.auth.getDnt();
  const effectiveDnt = api.auth.getDnt({
    includeDefaults: true
  });
  const updateDnt = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* (preference) {
      yield api.auth.setDnt(preference);
    });
    return function updateDnt(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    selectedDnt,
    effectiveDnt,
    updateDnt
  };
};
exports.useDNT = useDNT;